import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { TimeCell } from "../TimeCell/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index39.css';const timePanel = "_timePanel_1ogn9_1";
const wrapper = "_wrapper_1ogn9_13";
const hiddenCell = "_hiddenCell_1ogn9_21";
const s = {
  timePanel,
  wrapper,
  hiddenCell
};
const TimePanel = withThemeAndSize(
  forwardRef(({ className, headerValue, children, showTrailingCell = true, ...rest }, ref) => {
    return /* @__PURE__ */ jsxs("section", { ...rest, ref, className: clsx(s.timePanel, className), children: [
      headerValue,
      /* @__PURE__ */ jsxs("div", { className: s.wrapper, children: [
        children,
        showTrailingCell && /* @__PURE__ */ jsx(TimeCell, { className: s.hiddenCell })
      ] })
    ] });
  })
);
export {
  TimePanel
};
